import * as queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PAGES_HEAD_CONTENT from '../../../common/components/MetaData/constants';
import MetaData from '../../../common/components/MetaData/MetaData';
import { trackWebAppGAEvent } from '../../../common/helpers/plugins/website-google-analytics';
import { RouterComponentProps } from '../../../common/helpers/routes/interfaces';
import { useFacebookSessionCRUDActions } from '@mm/state/actions/FacebookSessionCRUDActions';
import { selectInviteToken } from '@mm/state/selectors/userSelector';
import './LoginPage.pcss';
import { LoginForm } from '../../../modules/LoginRouter/components/LoginForm/LoginForm';
import { LoginLayout } from '../../../modules/LoginRouter/components/LoginLayout/LoginLayout';

type Props = RouterComponentProps;

export const LoginPage = (props: Props) => {
  const inviteToken = useSelector(selectInviteToken);
  const { create: createFBSession } = useFacebookSessionCRUDActions();

  const [loginPending, setLoginPending] = useState(false);

  useEffect(() => {
    const extraParams: { email?: string } = {};
    if (props.location.search) {
      const params = queryString.parse(props.location.search);

      if (params.error === 'access_denied') {
        return;
      }
      if (params.email) {
        extraParams.email = params.email as string;
      }
      if (params.facebookToken) {
        createFBSession({
          facebookToken: params.facebookToken as string,
          inviteToken,
          ...extraParams,
        });
        return;
      }
    }
    if (props.location.hash) {
      const params = queryString.parse(props.location.hash);
      const facebookToken = String(params.access_token);
      if (facebookToken) {
        setLoginPending(true);
        trackWebAppGAEvent('login', {
          category: 'login',
          label: 'login_success',
        });
        createFBSession({
          facebookToken,
          inviteToken,
          ...extraParams,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (loginPending) {
      const loginTimeoutTimer = setTimeout(() => {
        setLoginPending(false);
      }, 2500);
      return () => clearTimeout(loginTimeoutTimer);
    }
  }, [loginPending]);

  return (
    <div className="login-page">
      <MetaData
        title={PAGES_HEAD_CONTENT.LOGIN.title}
        description={PAGES_HEAD_CONTENT.LOGIN.meta.description}
      />

      <LoginLayout>
        <LoginForm
          css={{
            container: 'login-page__form',
            heading: 'login-page__form-heading',
          }}
          heading="Log In"
          facebookLoginProps={{
            allowManualFlow: true,
            pending: loginPending,
            onClick: () => setLoginPending(true),
          }}
        />
      </LoginLayout>
    </div>
  );
};
